import dayjs from "dayjs";

function createDate(currentDate) {
    // const dateString = "Sat Jun 22 2024 00:00:00 GMT-0400 (Chile Standard Time)";
    const dateString = currentDate;

    // Create a new Date object
    const date = new Date(dateString);

    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate
}

function dateToPhrase(currentDate) {
    return dayjs(currentDate).format('MMMM D, YYYY')
}

export const dateUtils = { createDate, dateToPhrase };